// CMS helper service for Foreningen ØrBike

const CMS_BASE_URL = '/_api/public/content';
const CMS_V2_BASE_URL = '/_api/public/v2/content';

// Fallback seed data hvis kald ikke svarer
export const FALLBACK_EVENTS = [
  {
    id: "de6ea6ad-f999-4325-beb0-444bcfc34112",
    eventnavn: "ØrBike 2026",
    aarstal: "2026",
    dato: "2026-11-14",
    starttidspunkt: "Kl. 7.30",
    sluttidspunkt: "Kl. 19.00",
    lokation: "Ørbæk Midtpunkt",
    adresse: "Langemosevej 5, 5853 Ørbæk",
    kort_introduktion: "ØrBike er med +230 cykler et af Danmarks største indoor bike events og placeret lige midt i Danmark i Ørbæk Midtpunkt! 10 timers energi, sved, musik og motivation.",
    lang_beskrivelse: "<p>ØrBike afholdes altid den anden lørdag i november – en dag fyldt med energi, musik og fællesskab. Siden det første event i 2014 har ØrBike hvert år samlet hundredevis af ryttere i Ørbæk Midtpunkt til en dag, hvor vi cykler for livet og for hinanden.</p><p>Glæd dig til 10 timers energi, sved, musik og motivation i hjertet af Ørbæk. Vi sørger for energien, instruktørerne, lyset og hyggen – du skal bare vælge, hvor mange timer du vil være med!</p>",
    hero_billede: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/dreamfour-9995.jpg"],
    billetlink: "https://billet.eventbilletten.dk/seller/foreningen-rbike-zd1k",
    billetstatus: "Billetter til salg",
    velgoerende_formaal: "Børn med kritisk sygdom (Team Rynkeby, Børnecancerfonden & Børnelungefonden)",
    indsamlet_beloeb: "25.000 kr.",
    status: "aktiv",
    terms: { "begivenhed-status": ["aktiv"], "billet-status": ["til-salg"] }
  }
];

export const FALLBACK_PROGRAM = [
  { sortering: 1, tidspunkt: "Kl. 7.30", titel: "Dørene åbnes – check-in, morgenmad og omklædning", beskrivelse: "Check-in, morgenmadsbuffet og omklædning", instruktor_artist: "ØrBike Crew", scene_omraade: "Foyer & Spisesal" },
  { sortering: 2, tidspunkt: "Kl. 8.45", titel: "Officiel velkomst", beskrivelse: "Officiel åbning af eventet og praktisk information", instruktor_artist: "Jonas Reinholdt & JAS", scene_omraade: "Hovedsalen" },
  { sortering: 3, tidspunkt: "Kl. 9.00", titel: "ØrBike skydes i gang – Time 1", beskrivelse: "Første spinningtime skydes i gang med brag af lyd, lys og energi!", instruktor_artist: "Rikke Kirkegaard", scene_omraade: "Hovedscenen" },
  { sortering: 4, tidspunkt: "Kl. 10.00", titel: "Time 2", beskrivelse: "Jeppe Leth står klar med time 2", instruktor_artist: "Jeppe Leth", scene_omraade: "Hovedscenen" },
  { sortering: 5, tidspunkt: "Kl. 11.00", titel: "Time 3 – Fest i version 5.0", beskrivelse: "Henriette Damsted Fjord i en version 5.0 lover et brag af en fest", instruktor_artist: "Henriette Damsted Fjord (v. 5.0)", scene_omraade: "Hovedscenen" },
  { sortering: 6, tidspunkt: "Kl. 11.30", titel: "Frokostbuffet åbner", beskrivelse: "Frokostbuffet med salater, brød, lunt, kaffe og kage", instruktor_artist: "Buffet-teamet", scene_omraade: "Spisesalen" },
  { sortering: 7, tidspunkt: "Kl. 12.00", titel: "Time 4 – UK Guest Instructor", beskrivelse: "Liza Smith is taking on the stage - 1st time at ØrBike both on stage as well as amongst the participants and from the UK.", instruktor_artist: "Liza Smith (UK)", scene_omraade: "Hovedscenen" },
  { sortering: 8, tidspunkt: "Kl. 13.00", titel: "Time 5 – Johnny Roland – 25 års jubilæumstime", beskrivelse: "Johnny aka El'Diablo kører en uforglemmelig FEST-time og fejrer 25 års jubilæum", instruktor_artist: "Johnny Roland (El'Diablo)", scene_omraade: "Hovedscenen" },
  { sortering: 9, tidspunkt: "Kl. 14.00", titel: "Time 6 – Girl Power Party time", beskrivelse: "Girl Power Party time med Karina Friis og Nanna Vestergaard Madsen - nordjysk power i bedste stil", instruktor_artist: "Karina Friis & Nanna Vestergaard Madsen", scene_omraade: "Hovedscenen" },
  { sortering: 10, tidspunkt: "Kl. 15.00", titel: "Time 7 – Bobby Croshaws afskedstime", beskrivelse: "Et ikon indenfor indoor bike har valgt ØrBike som sin allersidste bike-time. Kæmpe fest og hyldest!", instruktor_artist: "Bobby Croshaw & Birgitte Junker", scene_omraade: "Hovedscenen" },
  { sortering: 11, tidspunkt: "Kl. 16.00", titel: "Time 8 – Københavnsk Energibombe", beskrivelse: "Line Susan Wingsted og Troels Kure-Rosenberg, energibomber fra København leverer en fest man ikke vil hjem fra!", instruktor_artist: "Line Susan Wingsted & Troels Kure-Rosenberg", scene_omraade: "Hovedscenen" },
  { sortering: 12, tidspunkt: "Kl. 17.00", titel: "Time 9 – Musikalsk stærk fest time", beskrivelse: "Kim Lahn har lovet en musikalsk stærk fest time - glæd dig!", instruktor_artist: "Kim Lahn", scene_omraade: "Hovedscenen" },
  { sortering: 13, tidspunkt: "Kl. 18.00", titel: "Time 10 – Årets sidste time", beskrivelse: "Årets sidste time køres af Jesper Skovhave nu også i en version 5.0", instruktor_artist: "Jesper Skovhave (v. 5.0)", scene_omraade: "Hovedscenen" },
  { sortering: 14, tidspunkt: "Kl. 18.30", titel: "Aftensmad serveres", beskrivelse: "Aftensmad serveres for tilmeldte ryttere og hjælpere", instruktor_artist: "Køkken-teamet", scene_omraade: "Spisesalen" },
  { sortering: 15, tidspunkt: "Kl. 19.00", titel: "ØrBike eventet slutter", beskrivelse: "10 timers sved, smil og motivation rundes af med stående applaus og fælles fejring", instruktor_artist: "Alle instruktører & ryttere", scene_omraade: "Hovedsalen" },
  { sortering: 16, tidspunkt: "Kl. 20.30", titel: "Aftensbuffeten lukker", beskrivelse: "1 x burger i take-away boks, dessert, øl og vand – hygge og afrunding", instruktor_artist: "Køkken-teamet", scene_omraade: "Spisesalen" }
];

export const FALLBACK_PARTNERE = [
  { partnernavn: "Broby IF", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/fb0be3a88fb4bf84a69c5ad49c170ad59ae335f9.png"], website: "https://brobyif.dk", beskrivelse: "Lokal idrætsforening og stolt samarbejdspartner", kategori: "Supporter Sponsors", aktiv: true, sortering: 1, eventaar: "2026" },
  { partnernavn: "Børnelungefonden", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/d5f17927710b0182c8fcf9d0bb68482db2aa53a9.png"], website: "https://boernelungefonden.dk", beskrivelse: "Støtter børn med kritiske lungesygdomme", kategori: "Elite Sponsors", aktiv: true, sortering: 2, eventaar: "2026" },
  { partnernavn: "allresq.nu", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/b1360f7660256e03c3894f09ead213d518ceaac4.png"], website: "https://allresq.nu", beskrivelse: "Be safe when you go high and low", kategori: "Core Sponsors", aktiv: true, sortering: 3, eventaar: "2026" },
  { partnernavn: "Jysk Kloak Renovering ApS", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/ed6d6e537118421021ab0db2f90bd3c41d1d03a1.png"], website: "https://jkr.dk", beskrivelse: "Professionel kloakrenovering – Tlf. 40 92 28 21", kategori: "Supporter Sponsors", aktiv: true, sortering: 4, eventaar: "2026" },
  { partnernavn: "Partner 1", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/eb2265d0fcf709dbd9e7addeec37e9dd4d743c75.png"], website: "", beskrivelse: "Stolt partner for ØrBike", kategori: "Core Sponsors", aktiv: true, sortering: 5, eventaar: "2026" },
  { partnernavn: "Partner 2", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/1f2c14afaff89edc675ce48e64954a100b4b71a3.png"], website: "", beskrivelse: "Stolt partner for ØrBike", kategori: "Core Sponsors", aktiv: true, sortering: 6, eventaar: "2026" },
  { partnernavn: "Partner 3", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/d9f07c300733d95846fe35e619517630e87121d4.png"], website: "", beskrivelse: "Stolt partner for ØrBike", kategori: "Core Sponsors", aktiv: true, sortering: 7, eventaar: "2026" },
  { partnernavn: "Partner 4", logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/56fa61466036647fef8619e7e6dd10daf453c1a9.png"], website: "", beskrivelse: "Stolt partner for ØrBike", kategori: "Core Sponsors", aktiv: true, sortering: 8, eventaar: "2026" }
];

export const FALLBACK_BESTYRELSE = [
  { navn: "Steffen Juncker", rolle: "Team Rynkeby Fonden", organisation: "Team Rynkeby Fonden", email: "stju@team-rynkeby.com", facebook: "https://www.facebook.com/steffen.juncker", sortering: 1 },
  { navn: "Jonas Reinholdt Albjerg", rolle: "Udpeget Formand af Team Rynkeby Fonden", organisation: "Team Rynkeby Fonden", email: "jonas@orbike.dk", telefon: "+45 30 93 62 72", facebook: "https://www.facebook.com/jonas.albjerg/", sortering: 2 },
  { navn: "Helle Holst Hansen", rolle: "Udpeget Næstformand af Team Rynkeby Fonden", organisation: "Team Rynkeby Fonden", email: "helle@orbike.dk", facebook: "https://www.facebook.com/helle.h.hansen.35", sortering: 3 },
  { navn: "Ann-Louise Greinert", rolle: "Udpeget Team Rynkeby repræsentant af Team Rynkeby Fonden", organisation: "Team Rynkeby Fonden", email: "ann-louise@teamrynkebyringe.dk", facebook: "https://www.facebook.com/annlouise.greinert", sortering: 4 }
];

export const FALLBACK_BILLETTYPER = [
  {
    titel: "Priority Cykel",
    underkategori: "Priskategori 1",
    pris: "5.550 kr.",
    pris_detalje: "inkl. moms pr. cykel - ekskl. ordregebyr",
    kort_beskrivelse: "Ideel profilering og team-oplevelse for virksomheder og større grupper",
    fordele: "<ul><li><strong>10 timers spinning</strong> i Danmarks mest energiske sal</li><li><strong>Placering på de 3 forreste rækker</strong> med optimalt udsyn til scenen</li><li><strong>Op til 10 deltagere pr. cykel</strong> (f.eks. én ny rytter for hver time)</li><li><strong>Logo på storskærme</strong> i pauser samt i spisesalen</li><li>Mulighed for at vise <strong>20–30 sek. video</strong> i pauser og på SoMe</li><li>Logo på sponsor-/selfievæg og takkeopslag på Facebook</li><li>Mulighed for at reservere eget spisebord i spisesalen</li><li>Støt et godt formål direkte med jeres CSR-engagement</li></ul>",
    badge: "Firma & Team Favorit",
    fremhaevet: true,
    billetlink: "https://billet.eventbilletten.dk/seller/foreningen-rbike-zd1k",
    sortering: 1
  },
  {
    titel: "Standard Cykel",
    underkategori: "Priskategori 2",
    pris: "2.225 kr.",
    pris_detalje: "inkl. moms pr. cykel - ekskl. ordregebyr",
    kort_beskrivelse: "For vennegrupper, spinning-entusiaster og motionister der vil cykle sammen",
    fordele: "<ul><li><strong>10 timers spinning</strong> fyldt med musik, energi og lysshow</li><li>Placering fra <strong>række 4 og bagud</strong> med god udsigt til scenen</li><li><strong>Op til 10 deltagere pr. cykel</strong> – del timerne som I vil</li><li>Adgang til hallens faciliteter, omklædning og badeforhold</li><li>Mulighed for tilkøb af frokost- og aftensmadsbuffet</li><li>Adgang til frugt, vand og energidrik undervejs</li><li>Et unikt fællesskab og en dag du aldrig glemmer</li></ul>",
    badge: "Populært valg",
    fremhaevet: false,
    billetlink: "https://billet.eventbilletten.dk/seller/foreningen-rbike-zd1k",
    sortering: 2
  }
];

export const FALLBACK_GENERELLT = {
  foreningsnavn: "Foreningen ØrBike",
  cvr: "45950433",
  telefon: "+45 30 93 62 72",
  email: "info@orbike.dk",
  adresse: "C/O Jonas Reinholdt Albjerg, Degnemosen 12, Tåsinge, 5700 Svendborg",
  arrangoerer: "Helle Holst Hansen og Jonas Reinholdt Albjerg",
  eventsted_navn: "Ørbæk Midtpunkt",
  eventsted_adresse: "Langemosevej 5, 5853 Ørbæk",
  facebook_url: "https://www.facebook.com/Orbike/",
  instagram_url: "https://www.instagram.com/orbike_eventet/",
  youtube_url: "https://www.youtube.com/channel/UCbp5b3RJPR4NbWml_U-joHw",
  logo: ["https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109/orbike-logo-1.png"]
};

export async function fetchCollection(collectionName, fallbackData = []) {
  try {
    const res = await fetch(`${CMS_BASE_URL}/${collectionName}`);
    if (!res.ok) {
      // Prøv alternativ sti hvis under andet hostname
      const altRes = await fetch(`https://api.dev.auxo.dk/public/content/${collectionName}`).catch(() => null);
      if (altRes && altRes.ok) {
        const altData = await altRes.json();
        if (Array.isArray(altData) && altData.length > 0) return altData;
        if (altData && Array.isArray(altData.items) && altData.items.length > 0) return altData.items;
      }
      return fallbackData;
    }
    const data = await res.json();
    if (Array.isArray(data) && data.length > 0) {
      return data;
    }
    if (data && Array.isArray(data.items) && data.items.length > 0) {
      return data.items;
    }
    return fallbackData;
  } catch {
    return fallbackData;
  }
}

export async function getBegivenheder() {
  // Henter primært fra 'begivenheder', med fallback til 'events'
  const items = await fetchCollection('begivenheder');
  if (items && items.length > 0) return items;
  return await fetchCollection('events', FALLBACK_EVENTS);
}

export async function getActiveEvent() {
  const events = await getBegivenheder();
  const active = events.find(e => {
    if (e.status === 'aktiv') return true;
    if (e.terms && Array.isArray(e.terms['begivenhed-status']) && e.terms['begivenhed-status'].includes('aktiv')) return true;
    return false;
  }) || events[0] || FALLBACK_EVENTS[0];
  
  // Normaliser billetstatus hvis den er en term
  if (!active.billetstatus && active.terms && active.terms['billet-status']) {
    const statusTerm = active.terms['billet-status'][0];
    if (statusTerm === 'til-salg') active.billetstatus = 'Billetter til salg';
    else if (statusTerm === 'udsolgt') active.billetstatus = 'Udsolgt';
    else if (statusTerm === 'snart') active.billetstatus = 'Snart til salg';
    else if (statusTerm === 'afsluttet') active.billetstatus = 'Afsluttet';
  }
  
  return active;
}

export async function getProgram() {
  const items = await fetchCollection('program', FALLBACK_PROGRAM);
  return items.sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}

export async function getPartnere() {
  const items = await fetchCollection('partnere', FALLBACK_PARTNERE);
  return items.filter(p => p.aktiv !== false).sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}

export async function getBestyrelse() {
  const items = await fetchCollection('bestyrelse', FALLBACK_BESTYRELSE);
  return items.sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}

export async function getBillettyper() {
  const items = await fetchCollection('billettyper', FALLBACK_BILLETTYPER);
  return items.sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}

export async function getFaq() {
  const items = await fetchCollection('faq');
  return items.filter(f => f.aktiv !== false).sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}

export async function getGenerelleIndstillinger() {
  const items = await fetchCollection('generelle_indstillinger');
  return (items && items[0]) || FALLBACK_GENERELLT;
}

export async function getSideindhold(sideFilter = null) {
  const items = await fetchCollection('sideindhold');
  if (sideFilter) {
    return items.filter(s => s.side === sideFilter);
  }
  return items;
}

export async function getVelgoerendeFormaal() {
  return await fetchCollection('velgoerende_formaal');
}

export async function getRegnskaber() {
  const items = await fetchCollection('regnskaber');
  return items.sort((a, b) => (Number(b.aar) || 0) - (Number(a.aar) || 0));
}

export async function getGallerier() {
  return await fetchCollection('galleri');
}

export async function getVideoer() {
  const items = await fetchCollection('videoer');
  return items.sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}

export async function getSider() {
  const items = await fetchCollection('sider');
  return items.sort((a, b) => (Number(a.sortering) || 0) - (Number(b.sortering) || 0));
}
